import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { BookingEditorCommercialModel } from '../../../services/booking-editor/booking-editor.model';
import { BookingEditorService } from '../../../services/booking-editor/booking-editor.service';

@Component({
  selector: 'sb-commercial-overview',
  templateUrl: './sb-commercial-overview.component.html',
  styleUrls: ['./sb-commercial-overview.component.scss'],
  standalone: false,
})
export class SbCommercialOverviewComponent implements OnInit, AfterViewInit {
  _commercialId: string;
  _leftPos: number;
  _widthPos: number = 0;
  _interval: number;
  initalPos: number;
  set interval(val) {
    this._interval = val;
  }

  get interval(): number {
    return this._interval;
  }

  @HostListener('document:scroll', ['$event'])
  public onViewportScroll() {}

  @Input() name;

  @Input() set leftPos(value: string) {
    this._leftPos = Number(value);
  }

  @Input() set widthPos(value: string) {
    this._widthPos = Math.round(Number(value));
  }

  @Input() set commercialId(value: string) {
    this._commercialId = value;
  }

  @ViewChild('cullPreview') cullPreview: ElementRef;
  @ViewChild('captions') captions: ElementRef;
  commercialEvent: BookingEditorCommercialModel | any;
  sideBarWidth: number;

  constructor(public bookingEditor: BookingEditorService) {}

  ngOnInit(): void {
    this.commercialEvent = this.bookingEditor.eventStore.getById(this._commercialId);
  }

  ngAfterViewInit(): void {
    this.sideBarWidth = this.captions.nativeElement.offsetWidth + this.cullPreview.nativeElement.offsetWidth + 50;
  }

  calcPos(): number {
    if (this._widthPos > this.sideBarWidth || !this._widthPos) {
      if (this.bookingEditor.leftPos >= this._leftPos + this._widthPos - this.sideBarWidth) {
        return this._widthPos - this.sideBarWidth;
      } else if (this.bookingEditor.leftPos < this._leftPos) {
        return 0;
      } else {
        return this.bookingEditor.leftPos - this._leftPos;
      }
    } else {
      return 0;
    }

    if (this.bookingEditor.leftPos >= this._leftPos && this.bookingEditor.leftPos > 0 && this._leftPos > 0) {
      return this.bookingEditor.leftPos - this._leftPos;
    }
    if (this.initalPos === this.bookingEditor.leftPos) {
      return 0;
    }
    if (this.bookingEditor.leftPos > 0 && this._leftPos <= 0) {
      let tempPos = this._leftPos * -1 + this.bookingEditor.leftPos;
      return tempPos;
    }
    if (this._leftPos > 0 || this._leftPos <= 0) {
      return 0;
    }
    return 0;

    if (this._widthPos > this.sideBarWidth || this._widthPos != null) {
      if (this.bookingEditor.leftPos >= this._leftPos + this._widthPos - this.sideBarWidth) {
        return this._widthPos - this.sideBarWidth;
      } else if (this.bookingEditor.leftPos < this._leftPos) {
        return 0;
      } else {
        debugger;
        if (this.bookingEditor.leftPos - this._leftPos <= 0) {
          return 0;
        } else if (this._leftPos <= 0) {
          const lef = this._leftPos * -1;
          return lef;
        }
        return this.bookingEditor.leftPos - this._leftPos;
      }
    } else {
      return 0;
    }
  }
}
